export default "__VITE_ASSET__DY5nWM7f__"